import { Button, Divider } from '@fullscreendigital/carrefour-dex-fe'
import { URLS } from '../../../constants'
import { useNavigate } from 'react-router-dom'
import { TitleHeader } from '../../../Common/TitleHeader'
import { TruckCard } from '../../../../admin/Common/TruckCard'
import { makeCoreGetRequest } from '../../../../../../utils/api'
import { formatErrorMessage } from '../../../../../../utils/formatting'
import { useNotification } from '../../../../../../hooks'
import { useQuery } from 'react-query'
import { CircularProgress, Container } from '@mui/material'
import { Grid } from '@mui/material'
import s from './ListTrucks.modules.scss'

const ListTrucks = () => {
  const navigate = useNavigate()
  const { showNotification } = useNotification()

  const { data: truckList, isLoading } = useQuery(
    'truckList',
    async () => {
      return await makeCoreGetRequest('/shop-reception-mobile/truck/shop', null)
    },
    {
      onError: error => {
        showNotification({
          message: `Error while fetching trucks. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  if (isLoading) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  }

  return (
    <Container className={s.gridContainer} maxWidth="xs" style={{ marginTop: '20px' }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TitleHeader title="Selecteazǎ Camion" />
        </Grid>
        <Grid item xs={12}>
          <Container className={s.gridContainer} maxWidth="xs">
            <Grid container spacing={1}>
              {truckList?.map((truck: any) => (
                <Grid item xs={12} key={truck.id}>
                  <TruckCard
                    onClick={() => {
                      navigate(URLS.AUTH_TRUCK_DETAIL.replace(':id', truck.id.toString()))
                    }}
                    truck={truck}
                  />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Grid>
        <Grid item xs={12}>
          <Divider>SAU</Divider>
        </Grid>
        <Grid item xs={12}>
          <Button
            type="button"
            variant="contained"
            label="CAUTǍ BL"
            style={{ width: '100%' }}
            onClick={() => {
              navigate(URLS.AUTH_TRUCK_SEARCH_DELIVERY_TICKET)
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            type="button"
            variant="contained"
            label="ADAUGǍ CAMION"
            style={{ width: '100%' }}
            onClick={() => {
              navigate(URLS.AUTH_ADD_TRUCK)
            }}
          />
        </Grid>
      </Grid>
    </Container>
  )
}

export default ListTrucks
